export default __webpack_public_path__ + "static/media/icon-youtube.69e49414.svg";